import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
  Field, Control, Input, Label, Help
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'

const UPDATE_MODULE = gql`
  mutation ($name: String!, $moduleId: UUID!) {
    updateModule(name: $name, moduleId: $moduleId) {
      module { id, name }
    }
  }
`

export default class UpdateModuleModal extends Component {
  state = {
    name: this.props.module.name,
    error: null
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  handleClose = (evt) => {
    this.setState(() => ({
      name: this.props.module.name,
      error: null
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (updateModuleMutation, evt) => {
    evt.preventDefault()
    const { name } = this.state

    if (name === '') {
      this.setState(() => ({
        error: 'Informe o novo nome do môdulo'
      }))
      return
    }

    try {
      await updateModuleMutation()

      this.setState(() => ({
        error: null
      }))

      this.props.handleClose(evt)
    } catch (e) {
      this.setState(() => ({
        error: 'Ocorreu um erro na comunicação com servidor'
      }))
      console.error(e)
    }
  }

  render() {
    const { name, error } = this.state
    const { isActive, module } = this.props

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>
        <Mutation mutation={UPDATE_MODULE} variables={{name: name, moduleId: module.id}}>
          {(updateModule, {loading}) => (
            <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, updateModule)}>
              <ModalCardHeader>
                <ModalCardTitle>Renomear môdulo</ModalCardTitle>
                <Delete onClick={this.handleClose} />
              </ModalCardHeader>
              <ModalCardBody>
                <Field>
                  <Control>
                    <Label>Nome</Label>
                    <Input type="text" placeholder={module.name} isColor={error ? 'danger' : null} autoFocus onChange={this.handleChange('name').bind(this)} value={name} />
                    {error && <Help isColor="danger">{error}</Help>}
                  </Control>
                </Field>
              </ModalCardBody>
              <ModalCardFooter>
                <Button type="submit" isLoading={loading} isColor="success">Salvar</Button>
                <Button onClick={this.handleClose}>Cancelar</Button>
              </ModalCardFooter>
            </ModalCard>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/modals/UpdateModuleModal.js